import React, { useEffect, useState, useCallback } from 'react'
import './clientDashboardDocuments.css';
import PortalHeader from '../clientNavbar/PortalHeader'
import { Link } from 'react-router-dom';

// Assets
import arrowDown from '../client-dashboard-assets/arrow-down.png'

// Particles Background Imports
import ParticleBackground from '../../components/particlesbackgroundForScrollable';
import { loadFull } from 'tsparticles';
import { loadPolygonMaskPlugin } from 'tsparticles-plugin-polygon-mask';
import { ZIndex, type Engine } from 'tsparticles-engine';

// Document Interface
interface myDocument {
    DOCUMENT_ID: number;
    DOCUMENT_NAME: string;
    DOCUMENT_DESCRIPTION: string;
    DOCUMENT_TYPE: string;
    DOCUMENT_SECTION: string;
    FILE_OR_URL: string;
    DOCUMENT_FILE: string | undefined;
    DOCUMENT_URL: string | undefined;
}


const clientDashboardDocuments2 = () => {

    // Preprocess galleryData once into a Map
    const [documentsDB, setDocumentsDB] = useState<myDocument[]>([]);

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top when the component mounts
    }, []);

    const fetchDetectorDocuments = async () => {
        try {
            const response = await fetch('/api/detectordashdocs', {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: 'same-origin',
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data: myDocument[] = await response.json();
            setDocumentsDB(data); // Assign the fetched gallery data to state
            // console.log(data)

        } catch (err) {
            // Type assertion to 'Error' to access the message property
            if (err instanceof Error) {
                console.error(err.message); // Handle error
            } else {
                console.error('An unknown error occurred'); // Fallback for unknown errors
            }
        }
    };

    useEffect(() => {
        fetchDetectorDocuments();
    }, []); // Empty dependency array to run once on mount

    // Partices Background
    const particlesInit = useCallback(async (main: Engine) => {
        await loadFull(main);
        await loadPolygonMaskPlugin(main);
    }, []);

    const [width, setWidth] = useState(window.innerWidth);
    const [heightTopParticles, setHeightTopParticles] = useState(width * 0.36);

    useEffect(() => {
        function handleResize() {
            setWidth(window.innerWidth);
            setHeightTopParticles(width * 0.36);
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [width]);

    // Click and expand dropdown logic
    const [expandedIndexes, setExpandedIndexes] = useState<Set<number>>(new Set());
    const [closingIndex, setClosingIndex] = useState<number | null>(null);

    const toggleExpand = (index: number) => {
        setExpandedIndexes(prev => {
            const newSet = new Set(prev);
            if (newSet.has(index)) {
                setClosingIndex(index);
                setTimeout(() => {
                    newSet.delete(index);
                    setExpandedIndexes(new Set(newSet)); // Force re-render
                    setClosingIndex(null);
                }, 300);
            } else {
                newSet.add(index);
            }
            return newSet;
        });
    };

    function getVideoId(url: any) {
        const match = url.match(/vimeo\.com\/(\d+)(?:\/(\w+))?/);
        if (match) {
            const id = match[1];
            const hash = match[2] ? `?h=${match[2]}` : '';
            return `${id}${hash}`;
        }
        return '';
    }

    return (
        <div className='document-bd'>
            <PortalHeader />

            
            {/* <ParticleBackground
                particlesInitBackground={particlesInit}
                id="topParticles"
                number={80}
                aspectRatio={width / heightTopParticles}
            /> */}

            <div style={{width:'100%', display:'flex', justifyContent:'flex-end', paddingRight:'2rem'}}>
                <Link className='faq-adjust-buttons' style={{textDecoration:'none', color:'black'}} to="/fnn_portal_video_hub" >
                    <button style={{paddingLeft:'1rem', paddingRight:'1rem'}}><strong>Back</strong></button>
                </Link>
            </div>


            <div className='tutorial-video-stack'>
                {documentsDB
                    .filter(doc => doc.DOCUMENT_TYPE === 'VIDEO' && doc.DOCUMENT_SECTION === 'Dashboard') // or whichever filter you want
                    .map((doc, index) => (
                        <div key={doc.DOCUMENT_ID} className='tutorial-video-item-wrapper'>
                            <div className='tutorial-video-item'>
                                <h1>{doc.DOCUMENT_NAME}</h1>
                                <img
                                    src={arrowDown}
                                    alt='drop-down-arrow'
                                    onClick={() => toggleExpand(index)}
                                    className={`tutorial-video-icon ${expandedIndexes.has(index) ? 'rotated' : ''}`}
                                />
                            </div>

                            {(expandedIndexes.has(index) || closingIndex === index) && (
                                <div className={`expandable2 ${closingIndex === index ? 'fade-out' : 'fade-in'}`}>
                                    <p>{doc.DOCUMENT_DESCRIPTION}</p>


                                    {doc.FILE_OR_URL === 'URL' && (
                                        <div className="vimeo-about">
                                            <iframe
                                                width="150vh"
                                                height="315"
                                                src={`https://player.vimeo.com/video/${getVideoId(doc.DOCUMENT_URL)}`}
                                                title="FNN YouTube video player"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                allowFullScreen
                                            ></iframe>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    ))}
            </div>
        </div>
    )
}

export default clientDashboardDocuments2